// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"be503fd0","186":"755a0568","209":"efcd4cf7","545":"70cf3b86"}[chunkId] + ".chunk.js";
};